function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20.46 3.54L3.54 20.46c-1-1-1.54-2.45-1.54-4.27V7.81C2 4.17 4.17 2 7.81 2h8.38c1.82 0 3.27.54 4.27 1.54zM22 7.81v6.09l-1.63-1.4c-.78-.67-2.04-.67-2.82 0l-4.16 3.57c-.71.61-1.83.67-2.61.15L21.61 5.39c.14.38.24.78.3 1.21.06.38.09.79.09 1.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 13.9v2.29c0 3.64-2.17 5.81-5.81 5.81H7.81c-.42 0-.83-.03-1.21-.09-.43-.06-.83-.16-1.21-.3l5.39-5.39c.78.52 1.9.46 2.61-.15l4.16-3.57c.78-.67 2.04-.67 2.82 0L22 13.9zm-.23-11.67c-.3-.3-.79-.3-1.09 0L2.23 20.69c-.3.3-.3.79 0 1.09a.758.758 0 001.08-.01L21.77 3.31c.31-.3.31-.78 0-1.08zM8 10.38a2.38 2.38 0 100-4.76 2.38 2.38 0 000 4.76z"
})));